module.exports = __webpack_public_path__ + "static/media/fb-icon.c44854cc.svg";